import type { ApiGetWorkflowResponseWithUsages } from '@jira/project-settings__project-configuration-commons';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

export type FetchParams = {
	cloudId: string;
	projectAndIssueTypes: {
		projectId: string;
		issueTypeId: string;
	}[];
};

/**
 * Stable function to fetch statuses and workflows
 */
export const fetchStatusesAndWorkflows = async ({
	cloudId,
	projectAndIssueTypes,
}: FetchParams): Promise<ApiGetWorkflowResponseWithUsages> => {
	try {
		const url = `/gateway/api/jira/project-configuration/query/${cloudId}/3/workflow`;

		const response: ApiGetWorkflowResponseWithUsages =
			await fetchJson<ApiGetWorkflowResponseWithUsages>(url, {
				method: 'POST',
				body: JSON.stringify({
					projectAndIssueTypes,
					skipUsageLookup: false,
				}),
			});

		return response;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		const isClientError = error.status >= 400 && error.status < 500;

		if (!isClientError) {
			fireErrorAnalytics({
				meta: {
					id: 'fetchStatusesAndWorkflows',
					packageName: 'jiraSoftwareBoard',
					teamName: 'crocs',
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});
		}

		throw error;
	}
};
